import { createApi } from '../common/API'


export const sharePlay = createApi('/share/play', {method:'POST'});

export const sharePublish = createApi('/share/publish', {method:'POST'});

export const shareDisplay = createApi('/share/display', {method:'POST'});
